<template>
  <v-app class="template">
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'TemplateDefault',
};
</script>

<style scoped lang="scss">
.template {
  background: transparent;
}
</style>
